var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('organism-add-service-data',{on:{"createNewService":_vm.onCreateNewService},model:{value:(_vm.serviceDetail),callback:function ($$v) {_vm.serviceDetail=$$v},expression:"serviceDetail"}})}
var staticRenderFns = []

export { render, staticRenderFns }